export default __webpack_public_path__ + "static/media/bharatPay.98583efc.png";